import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "filter-tag-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "filter-tag-list-header"
}
const _hoisted_4 = {
  key: 0,
  class: "filter-tag-list-header__title"
}
const _hoisted_5 = { class: "filter-tag-list__list" }

import type { SearchFormDataType } from '@interfaces/search-form';
import { computed, ref, onMounted } from 'vue';
import { EventBus } from '@global-js/event-bus';
import { useTranslations } from '@helper/composables/translations';

import { useStore } from '@/components/common/store';
import type { AdditionalCheckboxFilters, MostPopularFilters } from '@/interfaces/checkbox-filter-types';
import FilterAnalytics from '@/js/modules/analytics/FilterAnalytics';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import ChipBase from '@lmt-rpb/Atoms/ChipBase/ChipBase.vue';
import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import ShowMoreToggle from '@lmt-rpb/Atoms/ShowMoreToggle/ShowMoreToggle.vue';
import FilterHeader from '@lmt-rpb/FilterHeader/FilterHeader.vue';
import { useFilters } from 'src/composables/useFIlters';

interface Props {
	emitAnalytics?: boolean;
	showResetInHeader?: boolean;
	showHeaderTitle?: boolean;
	isModal?: boolean;
}

const maxItems = 8;


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterTagList',
  props: {
    emitAnalytics: { type: Boolean, default: true },
    showResetInHeader: { type: Boolean, default: false },
    showHeaderTitle: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false }
  },
  setup(__props: any) {



const isMounted = ref(false);
const store = useStore();

const showHeader = computed(() => __props.showResetInHeader || __props.showHeaderTitle);

const { translate } = useTranslations();

const { isMobile } = storeToRefs(useBreakpointStore());
const formData = computed((): SearchFormDataType => store.state.searchMask as SearchFormDataType);

const isCollapseOpen = ref(false);

const handleToggle = (b: boolean): void => {
	isCollapseOpen.value = b;
};

const { activeFilters: items } = useFilters();

const shouldCollapse = computed(() => {
	return isMobile.value && items.value.length > maxItems && !__props.showResetInHeader;
});

const visibleItems = computed(() => {
	if (shouldCollapse.value) {
		return items.value.slice(0, maxItems);
	}
	return items.value;
});

const hiddenItems = computed(() => {
	if (shouldCollapse.value) {
		return items.value.slice(maxItems);
	}
	return [];
});
const locationIdName = computed((): 'RegionID' | 'CityID' =>
	store.getters.locationType === 'COUNTRY' || store.getters.locationType === 'REGIONGROUP' ? 'RegionID' : 'CityID'
);
const onTagMounted = (label: string, type?: string) => {
	if (!isMounted.value || !__props.emitAnalytics) return;
	if (type === 'destinationTypes') {
		label = locationIdName.value === 'RegionID' ? 'Region' : 'Ort';
	}
	FilterAnalytics.createInstance(label).fireFilterSelected();
};

const resetAll = (): void => {
	store.dispatch('resetFormData');
	if (!__props.isModal) {
		EventBus.$emit('SearchMask:MobileSubmit');
	}
};

const resetFilter = (item: { label: string; value: string | boolean; type: string; attrType?: string }): void => {
	type FormDataKey = keyof typeof formData.value;
	if (['boardTypes', 'roomTypes', 'roomViews', 'transferTypes'].indexOf(item.type) !== -1) {
		// update stored value without this item
		const stored = formData.value[item.type as FormDataKey] as string[];

		const updated = item.type === 'roomViews' ? [] : stored.filter((storedItem: string) => storedItem !== item.value);
		store.dispatch('setFormData', {
			...formData.value,
			[item.type]: updated,
		});
	} else if (['mostPopularFilters'].indexOf(item.type) !== -1 && item.attrType) {
		const stored = formData.value[item.type as FormDataKey] as MostPopularFilters;
		type StoredDataKey = keyof typeof stored;
		const storedFilter = stored ? stored[item.attrType as StoredDataKey] : [];
		const updated = storedFilter?.filter((storedItem: string) => storedItem !== item.value);
		const storedMostPopular = formData.value.mostPopularFilters;
		store.dispatch('setFormData', {
			...formData.value,
			[item.type]: {
				...storedMostPopular,
				[item.attrType]: updated,
			},
		});
	} else if (['additionalCheckboxFilters'].indexOf(item.type) !== -1 && item.attrType) {
		const stored = formData.value[item.type as FormDataKey] as AdditionalCheckboxFilters;
		type StoredDataKey = keyof typeof stored;
		const storedFilter = stored ? stored[item.attrType as StoredDataKey] : [];
		const updated = storedFilter?.filter((storedItem: string) => storedItem !== item.value);
		const storedAdditionalCheckboxFilters = formData.value.additionalCheckboxFilters;
		store.dispatch('setFormData', {
			...formData.value,
			[item.type]: {
				...storedAdditionalCheckboxFilters,
				[item.attrType]: updated,
			},
		});
	} else {
		// reset stored value by init state
		store.dispatch('resetItem', item.type);

		// if type is destinationTypes we also need to reset the saved name
		if (['destinationTypes'].indexOf(item.type) !== -1) {
			store.dispatch('resetItem', 'destinationTypeName');
		} else if (['travelDuration'].indexOf(item.type) !== -1) {
			store.dispatch('resetItem', 'isTravelDurationExactSelected');
		}
	}

	if (!__props.isModal) {
		// update filters
		EventBus.$emit('SearchMask:MobileSubmit');
	}
};
onMounted(() => {
	isMounted.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(items).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.isModal && showHeader.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.showHeaderTitle || _ctx.showResetInHeader)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(translate)('filterTagList.selectedFilter')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.showResetInHeader)
                  ? (_openBlock(), _createBlock(LinkButton, {
                      key: 1,
                      label: _unref(translate)('delete'),
                      class: "filter-tag-list-header__reset-all",
                      "with-icon": false,
                      onClick: resetAll
                    }, null, 8 /* PROPS */, ["label"]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isModal)
            ? (_openBlock(), _createBlock(FilterHeader, {
                key: 1,
                title: _unref(translate)('filterTagList.selectedFilter'),
                "delete-button-string": _unref(translate)('delete'),
                "is-checked": true,
                class: "filter-tag-list-header",
                onDelete: resetAll
              }, null, 8 /* PROPS */, ["title", "delete-button-string"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.showResetInHeader)
              ? (_openBlock(), _createBlock(LinkButton, {
                  key: 0,
                  label: _unref(translate)('filterTagList.deleteAll'),
                  class: "filter-tag-list__reset-all",
                  "with-icon": false,
                  onClick: resetAll
                }, null, 8 /* PROPS */, ["label"]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createBlock(ChipBase, {
                key: item.type + item.label,
                class: "filter-tag-list__item",
                label: item.label,
                thin: true,
                "with-delete": true,
                onDeleteClick: ($event: any) => (resetFilter(item)),
                onClick: ($event: any) => (resetFilter(item)),
                onVnodeMounted: ($event: any) => (onTagMounted(item.label, item.type))
              }, null, 8 /* PROPS */, ["label", "onDeleteClick", "onClick", "onVnodeMounted"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenItems.value, (item) => {
              return (_openBlock(), _createBlock(_Transition, {
                key: item.type + item.label
              }, {
                default: _withCtx(() => [
                  (isCollapseOpen.value)
                    ? (_openBlock(), _createBlock(ChipBase, {
                        key: 0,
                        class: "filter-tag-list__item",
                        label: item.label,
                        thin: true,
                        "with-delete": true,
                        onDeleteClick: ($event: any) => (resetFilter(item)),
                        onClick: ($event: any) => (resetFilter(item)),
                        onVnodeMounted: ($event: any) => (onTagMounted(item.label, item.type))
                      }, null, 8 /* PROPS */, ["label", "onDeleteClick", "onClick", "onVnodeMounted"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          (shouldCollapse.value)
            ? (_openBlock(), _createBlock(ShowMoreToggle, {
                key: 2,
                "label-more": _unref(translate)('filterTagList.more'),
                "label-less": _unref(translate)('filterTagList.less'),
                "onShowMoreToggle:onToggle": handleToggle
              }, null, 8 /* PROPS */, ["label-more", "label-less"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})